function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.36 10.333h.78c.43 0 .777-.367.777-.665L9.5 1.665C9.5 1.298 9.152 1 8.724 1H6.776C6.347 1 6 1.368 6 1.665l.583 8.003c0 .368.348.665.776.665zM7.36 15h.78c.43 0 .777-.322.777-.582v-1.169c0-.322-.348-.582-.776-.582h-.782c-.428 0-.776.321-.776.582v1.169c0 .321.348.582.776.582z",
  fill: "currentColor"
})));